import classNames from 'classnames';

import Highlight from '@/src/components/Highlight/Highlight';

import styles from './TitleHighlighter.module.scss';

export function TitleHighlighter({ children, className }: Title.Props) {
    return (
        <Highlight
            boundaries={{ opening: '*', closing: '*' }}
            highlight={(text) => (
                <mark className={classNames(styles.highlighted, className)}>{text}</mark>
            )}
        >
            {children}
        </Highlight>
    );
}

export namespace Title {
    export interface Props {
        children: string;
        className?: string;
    }
}
